<template>
  <div>
    <v-layout wrap row justify-start pa-2>
      <v-flex xs12 md12 px-2 pb-2>
        <v-card class="elevation-24">
          <v-card-title :class="`headline white--text primary`">
            Product
            <v-spacer></v-spacer>
            {{ syncingProduct }}
            <v-btn color="success" @click="loadOld()" :loading="loading" :disable="loading" large>SYNC</v-btn>
            <v-autocomplete
              :items="newProducts"
              solo
              :disabled="loading"
              :loading="loading"
              return-object
              hide-details
              v-model="selectedProduct"
              label="Search a product"
              @change="loadNewProduct(selectedProduct)"
              item-text="item_name"
            >
              <template
                  slot="item"
                  slot-scope="{ parent, item }"
              >
                <v-list-tile-action>
                  <v-icon color="primary">amp_stories</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title v-html="item.item_name"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="item.sku"></v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-avatar v-if="item.img">
                  <img :src="item.img">
                </v-list-tile-avatar>
              </template>
            </v-autocomplete>
            <v-btn color="success" @click="loadNew()" :loading="loading" :disable="loading" large>reload</v-btn>
            <v-btn color="success" @click="startNewProduct()" :loading="loading" :disable="loading" large>new</v-btn>
            <v-btn color="success" @click="expProducts()">export</v-btn>
            <!-- <v-btn color="success" @click="importProduct(selectedProduct)">select</v-btn> -->
          </v-card-title>
        </v-card>
      </v-flex>
      <v-flex xs12 md6 px-2 pb-2>
        <v-card class="elevation-24">
          <v-card-title :class="`headline white--text primary`">
            Basic Info
            <v-spacer></v-spacer>
            <v-btn color="success" :loading="loading" :disable="newProductDP || loading" @click="basicInfo=!basicInfo">toggle</v-btn>
            <v-btn color="success" :loading="loading" :disable="newProductDP || loading" @click="updateProduct()">update</v-btn>
          </v-card-title>
          <v-card-text v-if="basicInfo && newProductDP">
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  label="Key"
                  name="Key"
                  disabled
                  v-model.trim="newProductDP.key"
                  box
                ></v-text-field>
                <input
                  type="file"
                  style="display: none"
                  ref="file"
                  accept="csv/*"
                  @change="onFilePicked"
                >
                <v-btn block color="success" @click="pickFile()">upload image</v-btn>
                <v-switch label="Active" v-model="newProductDP.active" @change="changeActive()"></v-switch>
              </v-flex>
              <v-flex xs6 class="text-xs-center" pa-2>
                <img :src="newProductDP.img" width="100%">
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="SKU"
                  name="SKU"
                  v-model.trim="newProductDP.sku"
                  box
                  :disabled="!creatingNewProduct"
                  @change="checkSkuIfNew(newProductDP.sku)"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Item Name"
                  name="Item Name"
                  v-model.trim="newProductDP.item_name"
                  box
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Name AR"
                  name="Name AR"
                  v-model.trim="newProductDP.name_ar"
                  box
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Name EN"
                  name="Name EN"
                  v-model.trim="newProductDP.name_en"
                  box
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <div>Product Note</div>
                <div><vue-editor :editor-toolbar="customConfig" v-model="newProductDP.note"></vue-editor></div>
              </v-flex>
              <v-flex xs12>
                <div>Description AR</div>
                <div><vue-editor :editor-toolbar="customConfig" v-model="newProductDP.description_ar"></vue-editor></div>
              </v-flex>
              <v-flex xs12>
                <div>Description EN</div>
                <div><vue-editor :editor-toolbar="customConfig" v-model="newProductDP.description_en"></vue-editor></div>
              </v-flex>
              <v-flex xs12>
                <div>Images</div>
                <div>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-layout row wrap>
                        <v-flex xs3 pa-1 v-for="(img, im) in newProductDP.imgs" :key="'imgs-'+im">
                          <img :src="img" width="100%">
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
                    </v-flex>
                    <v-flex xs12>
                      <input
                        type="file"
                        style="display: none"
                        ref="fileImages"
                        accept="csv/*"
                        @change="onFilePickedImages"
                      >
                      <v-btn block color="success" @click="pickFileImages()">upload images</v-btn>
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md6 px-2 pb-2>
        <v-card class="elevation-24">
          <v-card-title :class="`headline white--text primary`">
            Pricing
            <v-spacer></v-spacer>
            <v-btn color="success" :loading="loading" :disable="newProductDP || loading" @click="basicInfo=!basicInfo">toggle</v-btn>
            <v-btn color="success" :loading="loading" :disable="newProductDP || loading" @click="updateProduct()">update</v-btn>
            <v-btn color="success" :loading="loading" :disable="newProductDP || loading" @click="()=>{addTowWareHouses = true ; updateProduct()}">add to WHs</v-btn>
          </v-card-title>
          <v-card-actions v-if="basicInfo && newProductDP">
            <v-btn color="primary" block @click="()=>{
                newProductDP.prices.unshift({})
              }">add pricing</v-btn>
          </v-card-actions>
          <v-card-text v-if="basicInfo && newProductDP">
            <v-layout row wrap>
              <v-flex xs12  pa-2 class="elevation-2">
                <v-expansion-panel expand>
                  <v-expansion-panel-content v-for="(price, p) in newProductDP.prices" :key="'p-'+p">
                    <div slot="header">
                      <v-avatar size="12px" color="white">
                        <v-avatar size="10px" :color="`${new Date().getTime() < new Date(price.to).getTime() ? 'success': 'error'}`">
                        </v-avatar>
                      </v-avatar>
                      {{price.name}}
                    </div>
                    <v-card>
                      <v-card-text>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-text-field
                              label="Price Name"
                              name="Price Name"
                              v-model.trim="price.name"
                              box
                              hide-details
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field
                              label="Price Value"
                              name="Price Value"
                              v-model.trim="price.value"
                              box
                              :disabled="price.from && price.to? true: false"
                              @keypress="isNumber($event)"
                              hide-details
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-autocomplete
                              label="Price Countries"
                              name="Price Countries"
                              v-model.trim="price.country"
                              box
                              :disabled="price.from && price.to? true: false"
                              :items="countries"
                              multiple
                              hide-details
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs12>
                            <v-menu
                              v-model="fmenu[p]"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              lazy
                              v-if="price.value"
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="290px"
                            >
                              <template slot="activator">
                                <v-text-field
                                  v-model="price.from"
                                  label="From Date"
                                  append-icon="event"
                                  readonly
                                  box
                                  :disabled="!price.value"
                                  hide-details
                                  clearable
                                  :loading="loading"
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="price.from" @input="fmenu[p] = false"></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs12>
                            <v-menu
                              v-model="tmenu[p]"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              lazy
                              v-if="price.value"
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="290px"
                            >
                              <template slot="activator">
                                <v-text-field
                                  v-model="price.to"
                                  label="To Date"
                                  append-icon="event"
                                  readonly
                                  box
                                  :disabled="!price.value"
                                  hide-details
                                  clearable
                                  :loading="loading"
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="price.to" @input="tmenu[p] = false"></v-date-picker>
                            </v-menu>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    
  </div>
</template>

<script>
import {firebase, store, db, auth, storageRef } from '@/fb';
import { getRandomInt, randomString, getCDate, check, uuid } from '@/customFunction';
import json2csv from 'json2csv'
import { VueEditor, Quill } from "vue2-editor";

export default {
  components: {
    VueEditor
  },
  data(){
    return {
      loading:false,
      oldProducts:[],
      newProducts:[],
      selectedProduct:null,
      basicInfo:false,
      newProductDP:null,
      customConfig: [
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }, {list: "check"}],
        // ["image", "code-block"]
        ["clean"]
      ],
      file:null,
      uploadProgress:0,
      fmenu:{},
      tmenu:{},
      countries:[],
      ks: [
        'item_name', 
        'sku', 
        'description_ar', 
        'description_en', 
        'img', 
        'name_ar', 
        'name_en',
      ],
      syncingProduct:null,
      creatingNewProduct:false,
      warehouses:[],
      addTowWareHouses:false,
    }
  },
  methods:{
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    async loadOld(){
      this.creatingNewProduct = false
      this.loading = true
      let a = await db.ref(`products`)
			.once('value').then(x=>x.val())
      let b = Object.keys(a)
      let c = Object.values(a).map((x,i)=>{return{...x, key:b[i]}})//.filter(x=>Object.keys(x).length>4)
      let e = []
      let f = []
      c.forEach(x=>{
        if(!e.map(x=>x.sku).includes(x.sku)){
          e.push(x)
        } else {
          f.push(x)
        }
      })
      this.oldProducts = e;
      console.log(c)
      console.log(e)
      console.log(f);
      (async x=>{
        for (let i = 0; i < e.length; i++) {
          const p = e[i];
          await this.importProduct(p)
          console.log('done >', p.key)
          this.syncingProduct = p.sku
        }
        this.loading = false
        this.syncingProduct = ''
        console.log('all done')
      })()
    },
    loadNewProduct(p) {
      this.creatingNewProduct = false
      this.newProductDP = p
      this.basicInfo = true
    },
    async loadNew(){
      this.creatingNewProduct = false
      this.loading = true
      let a = await db.ref(`productsCore`)
			.once('value').then(x=>x.val())
      let b = Object.keys(a)
      let c = Object.values(a).map((x,i)=>{
        return {
          ...x, 
          key:b[i],
          prices:x.prices ? x.prices.map(n=>{return{...n, name:n.name.split('_').join(' ').trim().toUpperCase()}}) : [],
          imgs:x.imgs? x.imgs:[],
        }})
      this.newProducts = c
      this.loading = false
    },
    exportData(data, name){
      let a = json2csv.parse(data)
      console.log(a)
      let csvContent = "data:text/csv;charset=utf-8," 
      var encodedUri =  csvContent + encodeURIComponent(a);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      let n = name ? name : 'leads_export'
      link.setAttribute("download", `${n}.csv`);
      document.body.appendChild(link); // Required for FF

      link.click();
    },
    async expProducts(){
      let a = await db.ref(`products`)
			.once('value').then(x=>x.val())
      let b = Object.keys(a)
      let c = Object.values(a).map((x,i)=>{return{...x, key:b[i]}})
      this.exportData(c, 'products')
    },
    async importProduct(selectedProduct){
      return new Promise(async (res, rej)=>{
        delete selectedProduct.warehouse
        delete selectedProduct.clearance
        delete selectedProduct.import_date
        let initP = {};
        this.ks.push('key')
        this.ks.forEach(x=>{
          if(selectedProduct[x]) initP[x] = selectedProduct[x]
        })
        await db.ref(`productsCoreLite/${initP.key}`).update(initP)
        
        initP.prices = []
        let b = {}
        for (const key in selectedProduct) {
          if (selectedProduct.hasOwnProperty(key)) {
            const p = selectedProduct[key];
            if(p && p != '' && p!= ' ' && !Object.keys(initP).includes(key)) {
              b[key] = p
              initP.prices.push({
                name:key,
                value:p,
                from: '2018-01-01',
                to: '2025-12-31',
                country:['All'],
              })
            }
          }
        }
        initP.active = true
        console.log(initP)
        await db.ref(`productsCore/${initP.key}`).update(initP)
        res(true)
      })
    },
    pickFileImages(){
      this.$refs.fileImages.click()
    },
    pickFile() {
      this.$refs.file.click()
    },
    loadFile(file, type, ext){
      var file = file
      var metadata = {
        contentType: type
      };
      var uploadTask = storageRef.child('images/ashyaat' + randomString(8, 'Aa#') + '.' + ext).put(file, metadata);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        (snapshot)=> {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
					  this.uploadProgress = true
          }, (error) =>{
          console.log(error);

        switch (error.code) {

          case 'storage/unauthorized':
            break;
          case 'storage/canceled':
            break;
          case 'storage/unknown':
            break;
        }
      },() => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) =>{
					this.uploadProgress = false
          this.newProductDP.img = downloadURL
          console.log(downloadURL)
          this.loading = false
        });
      });
    },
    onFilePicked (e) {
      this.loading = true
      const files = e.target.files
      if(files[0] !== undefined) {
        const fr = new FileReader ()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.file = files[0] // this is an image file that can be sent to server...
          this.loadFile(this.file, this.file.type, this.file.name.split('.').pop())
        })
      } else {
        this.name = null
        this.uploadURL = null
      }
    },
    loadFileImages(file, type, ext){
      var file = file
      var metadata = {
        contentType: type
      };
      var uploadTask = storageRef.child('images/ashyaat' + randomString(8, 'Aa#') + '.' + ext).put(file, metadata);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        (snapshot)=> {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
					  this.uploadProgress = true
          }, (error) =>{
          console.log(error);

        switch (error.code) {

          case 'storage/unauthorized':
            break;
          case 'storage/canceled':
            break;
          case 'storage/unknown':
            break;
        }
      },() => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) =>{
					this.uploadProgress = false
          this.newProductDP.imgs.push(downloadURL)
          console.log(downloadURL)
          this.loading = false
        });
      });
    },
    onFilePickedImages (e) {
      this.loading = true
      const files = e.target.files
      if(files[0] !== undefined) {
        const fr = new FileReader ()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.file = files[0] // this is an image file that can be sent to server...
          this.loadFileImages(this.file, this.file.type, this.file.name.split('.').pop())
        })
      } else {
        this.name = null
        this.uploadURL = null
      }
    },
    async startNewProduct() {
      this.creatingNewProduct = true
      this.newProductDP = { prices:[] }
      this.ks.forEach(x=>{
        this.newProductDP[x] = ''
      })
      let a = await db.ref(`productsCore`).push()
      this.newProductDP.imgs = []
      this.newProductDP.key = a.key
      this.basicInfo = true

    },
    async getCountries(){
      let a = await db.ref(`settings/countrieslite`).once('value').then(x=>x.val())
      let b = Object.values(a).map(x=>x.name)
      b.unshift('All')
      this.countries = b
    },
    validate(){
      let v = true
      this.ks.forEach(x=>{
        if(!this.newProductDP[x]){
          this.$emit('snackbarNotification', `${x} is needed`, 'error')
          v = false
        }
      })
      if(this.newProductDP.prices && this.newProductDP.prices.length) {
        this.newProductDP.prices.forEach(x=>{
          if(Object.keys(x).length < 5) {
            this.$emit('snackbarNotification', `Price info missing`, 'error')
            v = false
          }
        })
      }
      return v
    },
    changeActive(){
      if(!this.newProductDP.active) {
        this.newProductDP.end_sku_date = new Date().getTime()
      }
    },
    async checkifSKUexists(sku){
      return new Promise(async (resolve, reject)=>{
        let a = await db.ref(`productsCore`).orderByChild('sku').equalTo(sku).once('value').then(x=>x.val())
        if(!a) {
          resolve(true)
        } else {
          resolve(false)
        }
      })
    },
    async checkSkuIfNew(sku){
      return new Promise(async (resolve, reject)=>{
        if(this.creatingNewProduct) {
          if(await this.checkifSKUexists(sku)) {
            resolve(true)
          } else {
            this.$emit('snackbarNotification', `SKU ALREADY EXISTS`, 'error')
            resolve(false)
          }
        } else {
          resolve(true)
        }
      })
    },
    async getWarehouses(){
      this.loading = true
      let a = await store.collection('warehouses').get().then(x=>x.docs.map(y=>y.data()))
      this.warehouses = a.map(x=>{
        return {
          quantity:0,
          warehouse:x.name
        }
      })
      console.log(this.warehouses)
      this.loading = false
    },
    async updateProduct() {
      this.loading = true
      console.log(JSON.stringify(this.newProductDP))
      if( this.validate() && await this.checkSkuIfNew(this.newProductDP.sku)){
        this.newProductDP.prices.map(x=>{return{...x, name:x.name.trim().split(' ').join('_').toLowerCase()}})
        await db.ref(`productsCore/${this.newProductDP.key}`).update(this.newProductDP)
        let { item_name, sku, description_ar, description_en, img, name_ar, name_en } = this.newProductDP
        let key = this.newProductDP.key
        let light = { item_name, sku, description_ar, description_en, img, name_ar, name_en, key }
        console.log(light)
        await db.ref(`productsCoreLite/${light.key}`).update(light)
        let ps = {}
        this.newProductDP.prices.forEach(x=>{
          ps[x.name.trim().split(' ').join('_').toLowerCase()] = x.value
        })
        let old = { item_name, sku, description_ar, description_en, img, name_ar, name_en, key, ...ps }
        console.log(old)
        await db.ref(`products/${old.key}`).update(old)
        if(this.creatingNewProduct || this.addTowWareHouses) {
          let wn = {
            item_name,
            key,
            sku,
            warehouses:this.warehouses
          }
          console.log(wn)
          await store.collection(`products`).doc(light.key).set(wn)
          await store.collection(`productsLive`).doc(light.key).set(wn)
        } else {
          let w = store.collection(`products`).doc(light.key).get().then(x=>x.data())
          if(w) {
            await store.collection(`products`).doc(light.key).update({item_name})
          } else {
            let p = await store.collection(`products`).where('sku', '==', item.sku.trim())
            .get().then(x=>x.docs.map(y=>{return {...y.data(), key:y.id}}))
            if(p && p[0]) {
              await store.collection(`products`).doc(p[0].key).update({item_name})
            }
          }
          let w2 = store.collection(`productsLive`).doc(light.key).get().then(x=>x.data())
          if(w2) {
            await store.collection(`productsLive`).doc(light.key).update({item_name})
          } else {
            let p = await store.collection(`productsLive`).where('sku', '==', item.sku.trim())
            .get().then(x=>x.docs.map(y=>{return {...y.data(), key:y.id}}))
            if(p && p[0]) {
              await store.collection(`productsLive`).doc(p[0].key).update({item_name})
            }
          }
        }
        this.newProductDP = null
        this.addTowWareHouses = false
        this.creatingNewProduct = false
        this.selectedProduct = null
        this.loading = false
        this.$emit('snackbarNotification', `Updated`, 'success')
        this.loadNew()
      }
    }
  },
  async created(){
    this.getCountries()
    this.getWarehouses()
    // this.loadOld()
    // await db.ref(`productsCore`).set(null)
    this.loadNew()
  }
}
</script>

<style>

</style>